import React, { useState, useEffect } from 'react';
import { t } from './translations';
import { CardNumberElement, CardExpiryElement, CardCvcElement, useStripe, useElements } from '@stripe/react-stripe-js';

const T = { soft:'#8892a4' };

function PBar({steps,cur}){
  return(
    <div className="pgbar">
      {Array.from({length:steps}).map((_,i)=>(
        <div key={i} className={'pbs'+(i<cur?' dn':i===cur?' ac':'')}/>
      ))}
    </div>
  );
}

export default function NewLoadModal({
  newLoadStep, setNewLoadStep,
  nlFrom, setNlFrom, nlTo, setNlTo, nlDate, setNlDate, nlTime, setNlTime,
  nlReceiverName, setNlReceiverName,
  nlPickupAddress, setNlPickupAddress, nlDeliveryAddress, setNlDeliveryAddress,
  pickupAddrStatus, deliveryAddrStatus,
  nlFromPostal, setNlFromPostal, nlToPostal, setNlToPostal,
  nlFromResults, nlToResults, nlFromSelected, nlToSelected,
  fromPostalStatus, toPostalStatus, selectFromPostal, selectToPostal,
  nlCargoType, setNlCargoType,
  nlPkgType, setNlPkgType, nlPallets, setNlPallets, nlPalletWeight, setNlPalletWeight,
  nlLength, setNlLength, nlWidth, setNlWidth, nlHeight, setNlHeight,
  nlWeight, setNlWeight, nlVehicle, setNlVehicle, nlPrice, setNlPrice, nlCargoValue, setNlCargoValue,
  nlInsured, setNlInsured, nlInsuranceMode, setNlInsuranceMode,
  nlPayerType, setNlPayerType, nlPayerEmail, setNlPayerEmail, nlPayerName, setNlPayerName,
  nlNotes, setNlNotes, serverDate,
  submitNewLoad, close,
  nlGeneratedRef, ensureLoadRef,
  CITY_NAMES, CARGO_TYPES, VEHICLE_TYPES, lang
}){
  const stripe=useStripe();
  const elements=useElements();
  const [paymentStatus,setPaymentStatus]=useState('idle'); // idle | processing | authorized | failed
  const [paymentError,setPaymentError]=useState('');
  const [cardReady,setCardReady]=useState(false);

  useEffect(()=>{
    if(newLoadStep!==4) return;
    setCardReady(false);
    const interval=setInterval(()=>{
      if(elements&&elements.getElement(CardNumberElement)){
        setCardReady(true);
        clearInterval(interval);
      }
    },300);
    return()=>clearInterval(interval);
  },[newLoadStep,elements]);

  const handlePaymentAuthorize=async()=>{
    if(!stripe||!elements) return;
    setPaymentStatus('processing');
    setPaymentError('');
    try{
      const loadRef=ensureLoadRef();
      const res=await fetch('https://oqnrxrowiewwrtroegwl.supabase.co/functions/v1/create-payment',{
        method:'POST',
        headers:{
          'apikey':'sb_publishable_WwQgxEBYbgBgCCpuC7hqTA_4pv48QMK',
          'Authorization':'Bearer sb_publishable_WwQgxEBYbgBgCCpuC7hqTA_4pv48QMK',
          'Content-Type':'application/json',
        },
        body:JSON.stringify({
          load_ref:loadRef,
          amount:parseInt(nlPrice)||0,
          payer_type:nlPayerType,
          payer_email:nlPayerEmail||null,
          payer_name:nlPayerName||null,
        }),
      });
      const data=await res.json();
      if(data.error||!data.client_secret){
        setPaymentError(data.error||'خطا در ساخت پرداخت');
        setPaymentStatus('failed');
        return;
      }
      const cardElement=elements.getElement(CardNumberElement);
      const {error,paymentIntent}=await stripe.confirmCardPayment(data.client_secret,{
        payment_method:{ card:cardElement },
      });
      if(error){
        setPaymentError(error.message);
        setPaymentStatus('failed');
        return;
      }
      if(paymentIntent&&paymentIntent.status==='requires_capture'){
        setPaymentStatus('authorized');
      }else{
        setPaymentError('وضعیت غیرمنتظره: '+paymentIntent?.status);
        setPaymentStatus('failed');
      }
    }catch(err){
      console.error('خطای کلی پرداخت بار جدید:',err);
      setPaymentError(String(err));
      setPaymentStatus('failed');
    }
  };
  if(newLoadStep===0) return(
    <div>
      <PBar steps={4} cur={0}/>
      <div className="ttl">{t(lang,'newLoadTitle')}</div>
      <div className="sub">{t(lang,'newLoadStep1Sub')}</div>
      <div className="sec-lbl">{lang==='de'?'Postleitzahl Abholort':'Pickup Postal Code'}</div>
      <input className="inp" placeholder={lang==='de'?'z.B. 30159':'e.g. 30159'} value={nlFromPostal} onChange={e=>setNlFromPostal(e.target.value)}/>
      {fromPostalStatus==='checking'&&<div style={{fontSize:11,color:'#fcd34d',marginBottom:10,marginTop:-4}}>⏳ {lang==='de'?'Wird geprüft...':'Checking...'}</div>}
      {fromPostalStatus==='invalid'&&<div style={{fontSize:11,color:'#fc8181',marginBottom:10,marginTop:-4}}>⚠️ {lang==='de'?'Postleitzahl ungültig':'Invalid postal code'}</div>}
      {fromPostalStatus==='multiple'&&(
        <div style={{marginBottom:10}}>
          <div style={{fontSize:11,color:T.soft,marginBottom:6}}>{lang==='de'?'Bitte auswählen:':'Please select:'}</div>
          {nlFromResults.map((opt,idx)=>(
            <div key={idx} onClick={()=>selectFromPostal(opt)} style={{padding:'8px 11px',background:'#181d25',border:'1px solid #232b36',borderRadius:8,marginBottom:6,fontSize:12,cursor:'pointer',color:'#e2e8f0'}}>{opt.label}</div>
          ))}
        </div>
      )}
      {fromPostalStatus==='confirmed'&&nlFromSelected&&<div style={{fontSize:11,color:'#86efac',marginBottom:10,marginTop:-4}}>✓ {nlFromSelected.label}</div>}

      <div className="sec-lbl">{lang==='de'?'Postleitzahl Zielort':'Delivery Postal Code'}</div>
      <input className="inp" placeholder={lang==='de'?'z.B. 80331':'e.g. 80331'} value={nlToPostal} onChange={e=>setNlToPostal(e.target.value)}/>
      {toPostalStatus==='checking'&&<div style={{fontSize:11,color:'#fcd34d',marginBottom:10,marginTop:-4}}>⏳ {lang==='de'?'Wird geprüft...':'Checking...'}</div>}
      {toPostalStatus==='invalid'&&<div style={{fontSize:11,color:'#fc8181',marginBottom:10,marginTop:-4}}>⚠️ {lang==='de'?'Postleitzahl ungültig':'Invalid postal code'}</div>}
      {toPostalStatus==='multiple'&&(
        <div style={{marginBottom:10}}>
          <div style={{fontSize:11,color:T.soft,marginBottom:6}}>{lang==='de'?'Bitte auswählen:':'Please select:'}</div>
          {nlToResults.map((opt,idx)=>(
            <div key={idx} onClick={()=>selectToPostal(opt)} style={{padding:'8px 11px',background:'#181d25',border:'1px solid #232b36',borderRadius:8,marginBottom:6,fontSize:12,cursor:'pointer',color:'#e2e8f0'}}>{opt.label}</div>
          ))}
        </div>
      )}
      {toPostalStatus==='confirmed'&&nlToSelected&&<div style={{fontSize:11,color:'#86efac',marginBottom:10,marginTop:-4}}>✓ {nlToSelected.label}</div>}
      <div className="sec-lbl">{t(lang,'pickupAddressLbl')}</div>
      <input className="inp" placeholder={t(lang,'pickupAddressPh')} value={nlPickupAddress} onChange={e=>setNlPickupAddress(e.target.value)}/>
      {pickupAddrStatus==='checking'&&<div style={{fontSize:11,color:'#fcd34d',marginBottom:10,marginTop:-4}}>⏳ {t(lang,'addressCheckingLbl')}</div>}
      {pickupAddrStatus==='valid'&&<div style={{fontSize:11,color:'#86efac',marginBottom:10,marginTop:-4}}>✓ {t(lang,'addressValidLbl')}</div>}
      {pickupAddrStatus==='invalid'&&<div style={{fontSize:11,color:'#fc8181',marginBottom:10,marginTop:-4}}>⚠️ {t(lang,'addressInvalidLbl')}</div>}
      <div className="sec-lbl">{t(lang,'deliveryAddressLbl')}</div>
      <input className="inp" placeholder={t(lang,'deliveryAddressPh')} value={nlDeliveryAddress} onChange={e=>setNlDeliveryAddress(e.target.value)}/>
      {deliveryAddrStatus==='checking'&&<div style={{fontSize:11,color:'#fcd34d',marginBottom:10,marginTop:-4}}>⏳ {t(lang,'addressCheckingLbl')}</div>}
      {deliveryAddrStatus==='valid'&&<div style={{fontSize:11,color:'#86efac',marginBottom:10,marginTop:-4}}>✓ {t(lang,'addressValidLbl')}</div>}
      {deliveryAddrStatus==='invalid'&&<div style={{fontSize:11,color:'#fc8181',marginBottom:10,marginTop:-4}}>⚠️ {t(lang,'addressInvalidLbl')}</div>}
      <div style={{fontSize:11,color:T.soft,marginBottom:10,marginTop:-4}}>ℹ️ {t(lang,'pickupAddressNote')}</div>
      <div className="sec-lbl">{t(lang,'receiverNameLbl')}</div>
      <input className="inp" placeholder={t(lang,'receiverNamePh')} value={nlReceiverName} onChange={e=>setNlReceiverName(e.target.value)}/>
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8}}>
        <div><div className="sec-lbl">{t(lang,'pickupDateLbl')}</div><input className="inp" type="date" value={nlDate} onChange={e=>setNlDate(e.target.value)}/></div>
        <div><div className="sec-lbl">{t(lang,'pickupTimeLbl')}</div><input className="inp" type="time" value={nlTime} onChange={e=>setNlTime(e.target.value)}/></div>
      </div>
      
      {nlDate&&new Date(nlDate)<new Date(new Date().setHours(0,0,0,0))&&<div className="warn-box">{t(lang,'dateNotPast')}</div>}
        {nlDate&&new Date(nlDate)>new Date(new Date().setHours(0,0,0,0)+7*86400000)&&<div className="warn-box">{t(lang,'dateMax7Days')}</div>}
      <button className="btn ba" disabled={!nlFromSelected||!nlToSelected||!nlDate||!nlTime||!nlReceiverName||new Date(nlDate)<new Date(new Date().setHours(0,0,0,0))||new Date(nlDate)>new Date(new Date().setHours(0,0,0,0)+7*86400000)} onClick={()=>setNewLoadStep(1)}>{t(lang,'continueBtn')}</button>
      <button className="btn bo" onClick={close}>{t(lang,'cancelBtn')}</button>
    </div>
  );
  if(newLoadStep===1) return(
    <div>
      <PBar steps={4} cur={1}/>
      <div className="ttl">{t(lang,'cargoDetailsTitle')}</div>
      <div className="sub">{t(lang,'newLoadStep2Sub')}</div>
      <div className="sec-lbl">{t(lang,'cargoTypeLbl')}</div>
      <select className="sel" value={nlCargoType} onChange={e=>setNlCargoType(e.target.value)}>
        <option value="">{t(lang,'selectCargoType')}</option>
        {CARGO_TYPES.map(c=><option key={c.k} value={c.k}>{c.icon} {c.name} {c.warn?'⚠':''}</option>)}
      </select>
      {nlCargoType&&CARGO_TYPES.find(c=>c.k===nlCargoType)?.warn&&<div className="warn-box">{t(lang,'adrWarning')}</div>}
      <div className="sec-lbl">{t(lang,'packagingTypeLbl')}</div>
      <div className="pkg-toggle">
        <button className={'pkg-btn'+(nlPkgType==='pallet'?' act':'')} onClick={()=>setNlPkgType('pallet')}>🟦 {t(lang,'onPallet')}</button>
        <button className={'pkg-btn'+(nlPkgType==='loose'?' act':'')} onClick={()=>setNlPkgType('loose')}>📐 {t(lang,'looseCargo')}</button>
      </div>
      {nlPkgType==='pallet'&&(<div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8}}>
        <div><div className="sec-lbl">{t(lang,'palletCountLbl')}</div><input className="inp" type="number" placeholder={t(lang,'example10')} value={nlPallets} onChange={e=>setNlPallets(e.target.value)}/></div>
        <div><div className="sec-lbl">{t(lang,'palletWeightLbl')}</div><input className="inp" type="number" placeholder={t(lang,'example500')} value={nlPalletWeight} onChange={e=>setNlPalletWeight(e.target.value)}/></div>
      </div>)}
      {nlPkgType==='loose'&&(<>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:8}}>
          <div><div className="sec-lbl">{t(lang,'lengthCm')}</div><input className="inp" type="number" placeholder="cm" value={nlLength} onChange={e=>setNlLength(e.target.value)}/></div>
          <div><div className="sec-lbl">{t(lang,'widthCm')}</div><input className="inp" type="number" placeholder="cm" value={nlWidth} onChange={e=>setNlWidth(e.target.value)}/></div>
          <div><div className="sec-lbl">{t(lang,'heightCm')}</div><input className="inp" type="number" placeholder="cm" value={nlHeight} onChange={e=>setNlHeight(e.target.value)}/></div>
        </div>
        <div className="sec-lbl">{t(lang,'totalWeightLbl')}</div>
        <input className="inp" type="number" placeholder={t(lang,'totalWeightPh')} value={nlWeight} onChange={e=>setNlWeight(e.target.value)}/>
      </>)}
      {nlPkgType==='pallet'&&nlPalletWeight&&(nlPalletWeight<100||nlPalletWeight>1500)&&<div className="warn-box">{t(lang,'palletWeightRangeWarning')}</div>}
      {nlPkgType==='pallet'&&nlPallets&&(nlPallets<1||nlPallets>66)&&<div className="warn-box">{t(lang,'palletCountRangeWarning')}</div>}
      <button className="btn ba" disabled={!nlCargoType||(nlPkgType==='pallet'?(!nlPallets||nlPallets<1||nlPallets>66||!nlPalletWeight||nlPalletWeight<100||nlPalletWeight>1500):(!nlLength||!nlWidth||!nlHeight||!nlWeight))} onClick={()=>setNewLoadStep(2)}>{t(lang,'continueBtn')}</button>
      <button className="btn bo" onClick={()=>setNewLoadStep(0)}>{t(lang,'backBtn')}</button>
    </div>
  );
  if(newLoadStep===2) return(
    <div>
      <PBar steps={4} cur={2}/>
      <div className="ttl">{t(lang,'shippingInfoTitle')}</div>
      <div className="sub">{t(lang,'newLoadStep3Sub')}</div>
      <div className="sec-lbl">{t(lang,'vehicleTypeNeeded')}</div>
      <div className="grid2" style={{marginBottom:13}}>
        {VEHICLE_TYPES.map(v=>(<div key={v.k} className={'opt'+(nlVehicle===v.k?' sel':'')} onClick={()=>setNlVehicle(v.k)}><div className="opt-icon">{v.icon}</div><div className="opt-name">{v.name}</div><div className="opt-sub">{v.sub}</div>{v.adr&&<div style={{fontSize:9,color:'#fc8181',marginTop:2,fontWeight:700}}>ADR</div>}</div>))}
      </div>
      <div className="sec-lbl">{t(lang,'suggestedPrice')}</div>
      <input className="inp" type="number" placeholder={t(lang,'example2500')} value={nlPrice} onChange={e=>setNlPrice(e.target.value)}/>
      <div className="sec-lbl">{t(lang,'cargoValueLbl')}</div>
        <input className="inp" type="number" placeholder={t(lang,'cargoValuePh')} value={nlCargoValue} onChange={e=>setNlCargoValue(e.target.value)}/>
        <div style={{fontSize:11,color:'#8892a4',marginBottom:10,marginTop:-4}}>🔒 {t(lang,'notShownToDriver')}</div>
      <div className="sec-lbl">{t(lang,'cargoInsuranceLbl')}</div>
        <div style={{display:'flex',flexDirection:'column',gap:8,marginBottom:10}}>
          <button className={'pkg-btn'+(nlInsuranceMode==='has'?' act':'')} onClick={()=>{setNlInsuranceMode('has');setNlInsured(true);}}>🛡 {t(lang,'hasFullInsurance')}</button>
          <button className={'pkg-btn'+(nlInsuranceMode==='euload'?' act':'')} onClick={()=>{setNlInsuranceMode('euload');setNlInsured(false);}}>⚡ {t(lang,'wantEuloadInsurance')}</button>
          <button className={'pkg-btn'+(nlInsuranceMode==='none'?' act':'')} onClick={()=>{setNlInsuranceMode('none');setNlInsured(false);}}>✕ {t(lang,'noInsurance')}</button>
        </div>
        {nlInsuranceMode==='euload'&&nlCargoValue&&(
          <div style={{background:'rgba(232,240,26,0.05)',border:'1px solid rgba(232,240,26,0.2)',borderRadius:10,padding:11,marginBottom:10,fontSize:12,color:T.soft}}>
            {t(lang,'euloadPremium')} <strong style={{color:'#e8f01a'}}>{Math.round(nlCargoValue*0.005)} EUR</strong> {t(lang,'percentValueNote')}
          </div>
        )}
        {nlInsuranceMode==='none'&&(
          <div className="warn-box">⚠️ {t(lang,'noInsuranceWarning')}</div>
        )}
      <div className="sec-lbl">{lang==='de'?'Wer bezahlt die Fracht?':'Who pays for the freight?'}</div>
      <div style={{display:'flex',flexDirection:'column',gap:8,marginBottom:10}}>
        <button className={'pkg-btn'+(nlPayerType==='sender'?' act':'')} onClick={()=>setNlPayerType('sender')}>📤 {lang==='de'?'Absender (ich)':'Sender (me)'}</button>
        <button className={'pkg-btn'+(nlPayerType==='receiver'?' act':'')} onClick={()=>setNlPayerType('receiver')}>📥 {lang==='de'?'Empfänger':'Receiver'}</button>
        <button className={'pkg-btn'+(nlPayerType==='third_party'?' act':'')} onClick={()=>setNlPayerType('third_party')}>🔗 {lang==='de'?'Dritte Partei':'Third party'}</button>
      </div>
      {nlPayerType!=='sender'&&(
        <>
          <div className="sec-lbl">{lang==='de'?'E-Mail des Zahlungspflichtigen':'Payer email'}</div>
          <input className="inp" type="email" placeholder={lang==='de'?'z.B. buchhaltung@firma.de':'e.g. accounting@company.com'} value={nlPayerEmail} onChange={e=>setNlPayerEmail(e.target.value.replace(/\s+/g,''))}/>
          {nlPayerEmail&&!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(nlPayerEmail)&&<div style={{fontSize:11,color:'#fc8181',marginTop:-8,marginBottom:10}}>{lang==='de'?'Ungueltige E-Mail-Adresse':'Invalid email address'}</div>}
          <div className="sec-lbl">{lang==='de'?'Name des Zahlungspflichtigen':'Payer name'}</div>
          <input className="inp" placeholder={lang==='de'?'z.B. Musterfirma GmbH':'e.g. Sample Company GmbH'} value={nlPayerName} onChange={e=>setNlPayerName(e.target.value)}/>
        </>
      )}
      <div className="sec-lbl">{t(lang,'extraNotesLbl')}</div>
      <textarea className="inp" rows={3} placeholder={t(lang,'extraNotesPh')} value={nlNotes} onChange={e=>setNlNotes(e.target.value)} style={{resize:'none',height:'80px'}}/>
      <button className="btn ba" disabled={!nlVehicle||!nlPrice||!nlCargoValue||(nlPayerType!=='sender'&&(!nlPayerEmail||!nlPayerName||!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(nlPayerEmail)))} onClick={()=>setNewLoadStep(3)}>{t(lang,'continueBtn')}</button>
      <button className="btn bo" onClick={()=>setNewLoadStep(1)}>{t(lang,'backBtn')}</button>
    </div>
  );
  if(newLoadStep===3){
    const cargo=CARGO_TYPES.find(c=>c.k===nlCargoType);
    const vehicle=VEHICLE_TYPES.find(v=>v.k===nlVehicle);
    const totalWeight=nlPkgType==='pallet'?((parseInt(nlPallets)||0)*(parseInt(nlPalletWeight)||0))+' kg':(parseInt(nlWeight)||0)+' kg';
    return(
      <div>
        <PBar steps={4} cur={3}/>
        <div className="ttl">{t(lang,'confirmSubmitTitle')}</div>
        <div className="sub">{t(lang,'newLoadStep4Sub')}</div>
        <div className="pb">
          {[[t(lang,'fromToLbl'),nlFrom+' → '+nlTo],[t(lang,'dateTimeLbl'),nlDate+' '+nlTime],[t(lang,'receiverLbl'),nlReceiverName],[t(lang,'cargoTypeLbl'),cargo?cargo.icon+' '+cargo.name:'—'],[t(lang,'packagingLbl'),nlPkgType==='pallet'?nlPallets+' '+t(lang,'palletsWord')+' '+nlPalletWeight+'kg':t(lang,'loosePrefix')+' '+nlLength+'×'+nlWidth+'×'+nlHeight+' cm'],[t(lang,'totalWeightLbl'),totalWeight],[t(lang,'fleetLbl'),vehicle?vehicle.icon+' '+vehicle.name:'—'],[t(lang,'priceLbl'),nlPrice+' EUR'],[t(lang,'insuranceLbl'),nlInsuranceMode==='has'?'🛡 '+t(lang,'fullInsurance'):nlInsuranceMode==='euload'?`⚡ ${t(lang,'euloadInsuranceParens')} (${Math.round(nlCargoValue*0.005)} EUR)`:'✕ '+t(lang,'noInsurance')],].map(([k,v])=>(<div key={k} className="prow" style={{marginBottom:7}}><span style={{fontSize:11,color:T.soft}}>{k}</span><span style={{fontSize:12,fontWeight:600,textAlign:'right',maxWidth:'60%',color:'#e2e8f0'}}>{v}</span></div>))}
        </div>
        {nlNotes&&<div style={{background:'rgba(136,146,164,0.05)',border:'1px solid #232b36',borderRadius:10,padding:10,marginBottom:13,fontSize:12,color:T.soft}}>{nlNotes}</div>}
        <div style={{fontSize:11,color:'#4a5568',textAlign:'center',marginBottom:14}}>{t(lang,'uniqueRefNote')}</div>
        <button className="btn ba" onClick={()=>{
          if(nlPayerType==='sender'){
            setNewLoadStep(4);
          }else{
            submitNewLoad();
          }
        }}>{nlPayerType==='sender'?(lang==='de'?'Weiter zur Zahlung':'Continue to payment'):t(lang,'submitPublishBtn')}</button>
        <button className="btn bo" onClick={()=>setNewLoadStep(2)}>{t(lang,'backBtn')}</button>
      </div>
    );
  }
  if(newLoadStep===4) return(
    <div>
      <PBar steps={5} cur={4}/>
      <div className="ttl">{lang==='de'?'Zahlungsautorisierung':'Payment Authorization'}</div>
      <div className="sub">{lang==='de'?'Bevor die Ladung veröffentlicht wird, muss die Karte autorisiert werden. Der Betrag wird erst nach erfolgreicher Lieferung abgebucht.':'Before the load is published, the card must be authorized. The amount will only be charged after successful delivery.'}</div>
      <div style={{background:'rgba(232,240,26,0.05)',border:'1px solid rgba(232,240,26,0.15)',borderRadius:10,padding:11,marginBottom:14,fontSize:12,color:T.soft}}>
        {lang==='de'?'Betrag':'Amount'}: <strong style={{color:'#e8f01a'}}>{nlPrice} EUR</strong>
      </div>
      <div style={{background:'#181d25',border:'1px solid #232b36',borderRadius:11,padding:'14px',marginBottom:10}}>
        <div style={{fontSize:11,color:T.soft,marginBottom:5}}>{lang==='de'?'Kartennummer':'Card number'}</div>
        <CardNumberElement options={{style:{base:{fontSize:'15px',color:'#e2e8f0','::placeholder':{color:'#4a5568'}},invalid:{color:'#fc8181'}}}}/>
      </div>
      <div style={{display:'flex',gap:10,marginBottom:14}}>
        <div style={{flex:1,background:'#181d25',border:'1px solid #232b36',borderRadius:11,padding:'14px'}}>
          <div style={{fontSize:11,color:T.soft,marginBottom:5}}>{lang==='de'?'Ablaufdatum':'Expiry'}</div>
          <CardExpiryElement options={{style:{base:{fontSize:'15px',color:'#e2e8f0','::placeholder':{color:'#4a5568'}},invalid:{color:'#fc8181'}}}}/>
        </div>
        <div style={{flex:1,background:'#181d25',border:'1px solid #232b36',borderRadius:11,padding:'14px'}}>
          <div style={{fontSize:11,color:T.soft,marginBottom:5}}>CVC</div>
          <CardCvcElement options={{style:{base:{fontSize:'15px',color:'#e2e8f0','::placeholder':{color:'#4a5568'}},invalid:{color:'#fc8181'}}}}/>
        </div>
      </div>
      {paymentStatus==='failed'&&<div className="warn-box">⚠️ {paymentError}</div>}
      {paymentStatus==='authorized'&&(
        <div style={{background:'rgba(34,197,94,0.07)',border:'1px solid rgba(34,197,94,0.25)',borderRadius:10,padding:11,marginBottom:14,fontSize:12,color:'#86efac',textAlign:'center'}}>✓ {lang==='de'?'Zahlung autorisiert':'Payment authorized'}</div>
      )}
      {paymentStatus!=='authorized'?(
        <button className="btn ba" disabled={paymentStatus==='processing'||!stripe||!cardReady} onClick={handlePaymentAuthorize}>
          {paymentStatus==='processing'?(lang==='de'?'Wird verarbeitet...':'Processing...'):(lang==='de'?'Karte autorisieren':'Authorize card')}
        </button>
      ):(
        <button className="btn ba" onClick={submitNewLoad}>{t(lang,'submitPublishBtn')}</button>
      )}
      <button className="btn bo" onClick={()=>setNewLoadStep(3)}>{t(lang,'backBtn')}</button>
    </div>
  );
  return null;
}
